import { TranslateService } from '@ngx-translate/core';
import { fromStepCondition, StepCondition } from '../../shared/data-sheet-filters.codec';

const PLACEHOLDER_ONLY = /^\{([^{}]+)\}$/;

/** `{vX}` steht im Satz als `vX`; die Klammern sind TCDL-Schreibweise, kein Teil des Namens. */
function withoutBraces(text: string): string {
  return text.replace(/\{([^{}]+)\}/g, '$1');
}

/** Eine Variable steht ohne Anfuehrungszeichen, ein fester Wert in „…" — so sieht man, was verglichen wird. */
function comparedValue(value: string, translate: TranslateService): string {
  const variable = PLACEHOLDER_ONLY.exec(value.trim());
  return variable ? variable[1] : translate.instant('runCondition.literal', { value });
}

function presenceKey(subj: string | undefined, op: string | undefined): string {
  const thing = subj === 'FENSTER' ? 'WINDOW' : 'OBJECT';
  return `runCondition.${thing}_${op === 'NOT_EXISTS' ? 'NOT_EXISTS' : 'EXISTS'}`;
}

/**
 * Eine Bedingung als Satz fuer die Frage im manuellen Lauf (NEX-2280), z. B. „vStatus ist „Fehler""
 * oder „Objekt wMaske.lblFehler ist vorhanden (wartet bis zu 3 s)". Gelesen wird ueber denselben
 * Parser wie im Editor, damit alle Aliase des Servers gelten.
 */
export function conditionText(condition: StepCondition, translate: TranslateService): string {
  const parsed = fromStepCondition(condition);
  if (!parsed.subj || !parsed.ref || !parsed.op) return translate.instant('runCondition.unknown');
  let text: string;
  if (parsed.subj === 'WERT') {
    text = translate.instant(`runCondition.value.${parsed.op}`, {
      operand: withoutBraces(parsed.ref),
      value: comparedValue(parsed.val ?? '', translate),
    });
  } else {
    text = translate.instant(presenceKey(parsed.subj, parsed.op), { ref: parsed.ref });
  }
  const seconds = Number(condition['timeoutSeconds']);
  return seconds > 0 ? `${text} ${translate.instant('runCondition.wait', { seconds })}` : text;
}

/** Alle Bedingungen eines Aufrufs, mit „und" verbunden; leer ohne Bedingung. */
export function conditionsText(conditions: StepCondition[] | undefined, translate: TranslateService): string {
  const and = ` ${translate.instant('runCondition.and')} `;
  return (conditions ?? []).map((condition) => conditionText(condition, translate)).join(and);
}
